import { useAppSelector } from 'store/hooks';
import { selectInviteAdvancedEnabled } from 'features/room/roomSlice';
import InviteUserAdvanced from './InviteUserAdvanced';
import InviteUserSimple from './InviteUserSimple';

const InviteUser = () => {
  const isAdvancedEnabled = useAppSelector(selectInviteAdvancedEnabled);

  return isAdvancedEnabled ? <InviteUserAdvanced /> : <InviteUserSimple />;
};

export default InviteUser;
